import { render, staticRenderFns } from "./EditProgramStations.vue?vue&type=template&id=35b0d4bc"
import script from "./EditProgramStations.vue?vue&type=script&lang=js"
export * from "./EditProgramStations.vue?vue&type=script&lang=js"
import style0 from "./EditProgramStations.vue?vue&type=style&index=0&id=35b0d4bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports